module.exports = __webpack_public_path__ + "img/month_switcher_arrow-right.f29934f5.svg";